import { MONITORING_LLM_LABELS } from "../../../utils/constant";
import { extractDomain } from "../../../utils/helpers";
import classes from "./SummaryCard.module.css";

export const CardTable = ({ llms = {}, llmDomains }) => {
  return (
    <div className="idReSe">
      <table className="table-sm w-100 text-center table-borderless">
        <thead>
          <tr style={{ color: "#7A7A7A", fontWeight: 500, lineHeight: "18px" }}>
            <th scope="col"></th>
            <th scope="col">Index</th>
            <th scope="col">Visibility</th>
            <th scope="col">Sentiment</th>
          </tr>
        </thead>
        <tbody>
          {/* Iterate through the LLMs dynamically */}
          {Object.keys(llms).map((llmName) => (
            <tr
              style={{
                color: "#7A7A7A",
                fontWeight: 500,
                lineHeight: "18px",
              }}
              key={llmName}
            >
              <th style={{ display: "flex", alignItems: "center" }} scope="row">
                <img
                  className={
                    llmName !== "llm-web" ? classes.logo : classes.logo2
                  }
                  src={
                    llmName === "llm-web"
                      ? "/menu.png"
                      : extractDomain(llmDomains?.[llmName]) === "google.com"
                        ? "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg"
                        : `https://img.logo.dev/${extractDomain(
                          llmDomains?.[llmName]
                        )}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`
                  }
                  alt={""}
                />
                &nbsp; &nbsp;
                <span>
                  {MONITORING_LLM_LABELS?.[llmName] || llmName}
                </span>
              </th>
              <td>
                {Number(llms?.[llmName]?.avg_brand_index_score).toFixed(0)}
              </td>
              <td>
                {Number(llms?.[llmName]?.avg_brand_reach_score).toFixed(0)}
              </td>
              <td>
                {Number(llms?.[llmName]?.avg_brand_favorability_score).toFixed(
                  0
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
